import {env} from "../../../res/config/env";

const LogoWithText = () => {

    return (
        <img alt="" className="auth-logo" src={env.CLIENT_LOGO + "logoWithText.png"}/>
    )
}

export default LogoWithText;